export const LIST_CUSTOMER_METADATA_REQUEST = 'LIST_CUSTOMER_METADATA_REQUEST';
export const LIST_CUSTOMER_METADATA_SUCCESS = 'LIST_CUSTOMER_METADATA_SUCCESS';
export const CUSTOMER_METADATA_LIST_REQUESTING =
  'CUSTOMER_METADATA_LIST_REQUESTING';
export const RESET_CUSTOMER_METADATA_ISFETCHING =
  'RESET_CUSTOMER_METADATA_ISFETCHING';
